import React from "react";
import {
  useRoutes,
} from "react-router-dom";
import AboutUspage from "../Pages/AboutUsPage/aboutUs";
import ContactUsPage from "../Pages/ContactUsPage/contactUsPage";
import BlogsPage from "../Pages/BlogsPage/blogsPage";
import ProductPage from "../Pages/ProductPage/productPage";
import HomePage from "../Pages/HomePage/homePage";
import { HomeInterior } from "../Pages/ProductPage/productspages/HomeInterior/homeInterior";
import { TermConditionspage } from "../Pages/TermsCondition/terms&ConditionsPage";
import { PravicyPolicy } from "../Pages/TermsCondition/pravicyPolicy";
import useScrollToTop from "../CommonComponents/useScrolletoTop";
import { BlogDetailsPage } from "../Pages/BlogsPage/BlogDetailsPage";
import UpvcVariantPage from "../Pages/ProductPage/productspages/UPVCpages/upvcVariantPage";
import { ProductDetailsPage } from "../Pages/ProductPage/productspages/SingleProducts/productDetailspage";
import AccessoriesShopPage from "../Pages/ProductPage/productspages/SingleProducts/accessoriesShopPage";
import RecentProject from "../Pages/ProductPage/productspages/SingleProducts/recentProject";
import AccessoriesPage from "../Pages/ProductPage/productspages/SingleProducts/accessoriesPage";
import RecentProjectPage from "../Pages/RecentProjectPage/recentProjectPage";
import PageTitle from "../CommonComponents/pageTitle";
import { useSelector } from "react-redux";
import { BecomeAdealerPage } from "../Pages/BecomeADealerPage/becomeAdealerPage";
import { NotFoundPage } from "../Pages/notFoundPage";
import CertificationPage from "../Pages/CertificationPage/CertificationPage";

function ProjectRoutes() {
  const progress = useSelector((state) => state.slugData.progress);
  //   // console.log(progress, 'progress');

  useScrollToTop();

  const elements = useRoutes([
    {
      path: "/",
      element: (
        <>
          <PageTitle
            title={
              "Aluminium door and window in rajasthan | Best Upvc door and window."
            }
          ></PageTitle>
          <HomePage
            title="Best upvc door and window | glass shower cubical | upvc aluminium door and window"
            description="Elevate Your Space with best UPVC Doors and Windows. Discover our range of stylish upvc aluminium door and window and energy-efficient solutions for homes and businesses"
            keyword="Best upvc window and door, Glass wall office partition, glass shower cubical, interior designer in faridabad, Coloured upvc window and door, best pvc door company, upvc window sliding door, best upvc aluminium door and window, best upvc door in faridabad"
          />
        </>
      ),
    },
    {
      path: "/about-us/",
      element: (
        <>
          <PageTitle
            title={
              "About us | Entrance matting System | upvc window in delhi NCR"
            }
          ></PageTitle>
          <AboutUspage
            title="About us | Best pvc door company | upvc window sliding door | best upvc door in faridabad"
            description="We are the best pvc door company and we offers a range of high-quality UPVC doors and windows designed to enhance your home's aesthetics and functionality."
            keyword="Best upvc window and door, Glass wall office partition, glass shower cubical, interior designer in faridabad, Coloured upvc window and door, best pvc door company, upvc window sliding door, best upvc aluminum door and window, best upvc door in faridabad"
          />
        </>
      ),
    },
    {
      path: "/locate-us/",
      element: (
        <>
          <PageTitle
            title={"Tube Flex India | locate us | Entrance Matting System"}
          ></PageTitle>
          <ContactUsPage
            title="Tube Flex India | locate us"
            description="If you have comments, queries, or questions about home interiors and upvc window and door, please call us on 99969 70583 and speak to our design experts."
            keyword="Tube Flex India, contact us, commercial partition system, office space partition, glass wall office partition,  coloured upvc door and window, type of upvc door and window, upvc window sliding door, upvc window and door, Aluminium Skirting, led skirting, Best upvc window and door, Glass wall office partition, glass shower cubical, interior designer in faridabad, best pvc door company, best upvc aluminum door and window, best upvc door in faridabad"
          />
        </>
      ),
    },
    {
      path: "/blogs/",
      element: (
        <>
          <PageTitle
            title={
              "Blog | Aluminium Skirting | Led skirting | Aluminium Shower cubicle | Interior designer faridabad"
            }
          ></PageTitle>
          <BlogsPage
            title="Blog | Aluminium Skirting | Led skirting | Aluminium Shower cubicle | Interior designer faridabad"
            description="Best upvc window and door, Glass wall office partition, glass shower cubical, interior designer in faridabad, Coloured upvc window and door, best pvc door company, upvc window sliding door, best upvc aluminum door and window, best upvc door in faridabad"
            keyword="Tube Flex India provides you the best aluminium skirting and led skirting freedom to create custom doors that perfectly complement the aesthetic and style of your spaces"
          />
        </>
      ),
    },
    { path: "/products/:slug", element: <>{progress && <PageTitle title={progress} ></PageTitle>}<ProductDetailsPage /></> },
    { path: "/:slug", element: <>{progress &&<PageTitle title={progress}></PageTitle>}<HomeInterior /></> },
    { path: "/terms-&-Condition/", element: <TermConditionspage /> },
    { path: "/privacy-policy/", element: <PravicyPolicy /> },
    { path: "/blog-details-page/:slug", element: <BlogDetailsPage /> },
    { path: "/:slug/:slug", element: <>{progress && <PageTitle title={progress} ></PageTitle>}<UpvcVariantPage /> </>},
    {
     path: '/become-a-dealer/',
     element: <><PageTitle title={"Become a Dealer | Upvc window in delhi NCR"} ></PageTitle><BecomeAdealerPage/></>
    },
    { path: "/accessories-shop/:slug", element: <AccessoriesShopPage /> },
    { path: "/accessories/:slug", element: <AccessoriesPage /> },
    { path: "/recent-project/:slug", element: <RecentProject /> },
    { path: "/all-recent-project/", element: <RecentProjectPage /> },
    { path: "/not-found", element: <NotFoundPage /> },
    { path: "/certification", element: <CertificationPage/>},
    { path: "*", element: <NotFoundPage /> },
  ]);

  return elements;
}
export default ProjectRoutes;
